import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { container } from '@/app/container';
import { CatalogRepositoryToken } from '../../di/tokens';

/** Uma linha por capacidade `(type, key)`; a paginação conta capacidades. */
export function usePerkGroups(page = 1, perPage = 10) {
  const repository = container.resolve(CatalogRepositoryToken);
  return useQuery({
    queryKey: ['catalog', 'perks', page, perPage],
    queryFn: () => repository.listPerkGroups({ page, perPage }),
    staleTime: 1000 * 60 * 5,
    placeholderData: keepPreviousData,
  });
}

/** O catálogo inteiro, para as telas que escolhem um perk numa lista. */
export function useAllPerkGroups() {
  const repository = container.resolve(CatalogRepositoryToken);
  return useQuery({
    queryKey: ['catalog', 'perks', 'all'],
    queryFn: () => repository.listAllPerkGroups(),
    staleTime: 1000 * 60 * 5,
  });
}

/**
 * `kind → params exigidos`, direto do back. É constante do domínio (cacheia
 * longo), e a UI **não** mantém uma cópia dessa tabela.
 */
export function useGrantPolicySpecs() {
  const repository = container.resolve(CatalogRepositoryToken);
  return useQuery({
    queryKey: ['catalog', 'grant-policy-kinds'],
    queryFn: () => repository.listGrantPolicySpecs(),
    staleTime: 1000 * 60 * 60,
  });
}
